export const HTTP_STATUS = Object.freeze({
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    TOO_MANY_REQUESTS: 429,
    SERVICE_UNAVAILABLE: 503,
} as const);
